var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{staticStyle:{"width":"100%","position":"absolute","top":"60px","border-top":"1px solid #f5f5f5"},attrs:{"src":_vm.loginUrl,"scrolling":"no","frameborder":"0","name":"ifd","height":_vm.$route.params.type === 'console' ? '1000' : '1700'}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f17dee4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/gtn/views/frontViews/cooperate.vue
// module id = null
// module chunks = 